import { State } from '../../interfaces/State';
import { StreakInfoState } from '../reducers/streakInfo';

export const selectStreakInfo = (state: State): StreakInfoState =>
  state.get('streakInfo');
